<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section">
        <h5 class="table-title">History</h5>
      </div>
      <div class="second-section d-flex align-items-center justify-content-end">
        

        <ng-template [ngxPermissionsOnly]="['History:Delete']">
          <span matTooltip="Delete Record(s)" matTooltipPosition="above">
            <button class="btn filter-btn" data-toggle="modal" data-target="#deleteDataModal"
              aria-label="OpenDeleteModal">
              <img style="width: 22px" src="../../../assets/Pricingscreen/delete.svg" />
            </button>
          </span>
        </ng-template>
        
        <ng-template [ngxPermissionsOnly]="['History:Print']">
          <span matTooltip="Print Records" matTooltipPosition="above">
            <button class="btn filter-btn ms-2" data-toggle="modal" aria-label="OpenDeleteModal"
              (click)="printMultiple()">
              <i class="fa-solid fa-print" style="color: #676767; font-size: 1.2rem"></i>
            </button>
          </span>
        </ng-template>

        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button class="btn filter-btn ms-2" data-bs-target="#filterData" data-bs-toggle="modal">
            <i><img style="width: 25px" src="../../../assets/Pricingscreen/filter.svg" /></i>
          </button>
        </span>

        <div class="date-range1 d-flex">
          <input type="text" name="daterangeInput" daterangepicker #dateRange [options]="options"
            (selected)="selectedDate($event)" style="width: 15rem" />
          <img src="assets/dashboard/datepicker.svg" class="svg-icon" (click)="openCalender()" style="height: 1.2rem" />
        </div>
        <div class="searchbar d-flex ms-2">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input type="text" placeholder="Search Barcode" [(ngModel)]="barcodes" (keyup)="searcha($event)" />
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <div class="table-scroll-area">
      <table class="table category-table table-condensed" *ngIf="!isLoading && isHistory">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" class="text-trasnform" style="align-items: center">
              <div class="form-check mb-0">
                <input style="height: 20px; width: 20px; margin-right: 10px" class="form-check-input"
                  id="flexCheckDefault1" type="checkbox" (click)="toggleCheckBox($event)" />
                <label class="ms-2 text-nowrap" for="flexCheckDefault" style="font-size: 14px; font-weight: 700">Date &
                  Time Created</label>
                <i class="fa-regular ms-1 fa-circle-xmark text-danger" (click)="clearFilter('Dates')"
                  *ngIf="showDates"></i>
              </div>
            </th>
            <th scope="col" class="text-nowrap text-trasnform">
              Date Produced For
            </th>
            <th scope="col" class="text-trasnform">Store Name</th>
            <th scope="col" class=" text-nowrap text-trasnform">
              <div class="d-flex align-items-center">Produced At &nbsp;

                <i class="fa-regular fa-circle-xmark text-danger" (click)="clearFilter('Print')"
                  *ngIf="equalsZero || greaterZero" style="cursor: pointer;"></i>
              </div>
            </th>
            <th *ngIf="showWeekColor" scope="col" class="text-nowrap text-trasnform">
              Week Color &nbsp;
              <i class="fa-regular fa-circle-xmark text-danger" (click)="clearFilter('Color')"
                *ngIf="filterColorIDs.length > 0"></i>
            </th>
            <th scope="col" class="text-trasnform">
              Departments &nbsp;
              <i class="fa-regular fa-circle-xmark text-danger" (click)="clearFilter('Department')"
                *ngIf="filterDepartmentIDs.length > 0"></i>
            </th>
            <th scope="col" class="text-trasnform">
              Category &nbsp;
              <i class="fa-regular fa-circle-xmark text-danger" (click)="clearFilter('Category')"
                *ngIf="filterCategoriesIDs.length > 0"></i>
            </th>
            <th scope="col" class="text-trasnform">Quantity</th>
            <th scope="col" class="text-trasnform">Pieces</th>
            <th scope="col" class="text-trasnform">Price</th>
            <th scope="col" class="text-trasnform">Barcode</th>
            <th scope="col" class="text-nowrap text-trasnform">Produced By</th>
            <th scope="col" class="text-trasnform" style="text-align: center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of pagedData; let i = index">
            <td class="d-flex g-2" style="align-items: center">
              <div class="form-check">
                <input style="height: 20px; width: 20px; margin-right: 10px" class="form-check-input" type="checkbox"
                  id="flexCheckDefault1" type="checkbox" [checked]="history.isPrintChecked"
                  (click)="toggleItem(history.barcode)" />
              </div>
              <label class="ms-2" for="" style="font-size: 14px; font-weight: 700">{{ history.dateCreated | date :
                "MM/dd/yyyy h:mm a" }}</label>
            </td>
            <td class="text-nowrap">
              {{ history.producedForDate | date : "MM/dd/yyyy" }}
            </td>
            <td class="text-start">{{ history.storeName }}</td>
            <td>{{ history.locationName }}</td>
            <td *ngIf="showWeekColor">
              <span class="bgColor" [style.backgroundColor]="history.color"></span>
            </td>
            <td>{{ history.departmentDescr }}</td>
            <td>{{ history.categoryName }}</td>
            <td>
              <div *ngIf="editableRowIndex !== i" style="text-align: end; padding-right: 30px; width: 80px">
                {{ history.qty }}
              </div>
              <input *ngIf="editableRowIndex === i" class="text-inp" type="text" [(ngModel)]="history.qty"
                style="text-align: end; padding-right: 30px; width: 82px" />
            </td>
            <td style="text-align: end; padding-right: 30px; width: 80px">
              {{ history.numberOfPieces }}
            </td>
            <td style="text-align: end; padding-right: 30px; width: 80px">
              {{ history.price | currency }}
            </td>
            <td>{{ history.barcode }}</td>
            <td class="text-nowrap">{{ history.userName }}</td>
            <td style="text-align: center">
              <div class="btn-group dropleft">
                <button *ngIf="editableRowIndex === i" type="button" class="action-drop me-2"
                  (click)="saveQty(i, history.barcode, history.qty)">
                  <i><img width="20" src="../../../assets/Pricingscreen/save.svg" /></i>
                </button>
                <button *ngIf="editableRowIndex === i" type="button" class="action-drop me-2" (click)="cancel(i)">
                  <i><img width="20" src="../../../assets/Pricingscreen/cancel.svg" /></i>
                </button>

                <!--<button *ngIf="editableRowIndex !== i" type="button" class="action-drop me-2">
                          <i><img width="20" src="../../../assets/Pricingscreen//update.svg" (click)="toggleEditMode(i)" /></i>
                        </button>-->
                <ng-template [ngxPermissionsOnly]="['History:Print']">
                  <span matTooltip="Print Barcode" matTooltipPosition="above">
                    <button *ngIf="editableRowIndex !== i" type="button" class="action-drop me-2 svg-icon"
                      (click)="checkLabel(history.barcode)">
                         <i class="fa-solid fa-print" style="color: #676767; font-size: 1.2rem"></i>
                    </button>
                  </span>
                </ng-template>
                <ng-template [ngxPermissionsOnly]="['History:Delete']">
                  <span matTooltip="Delete Record" matTooltipPosition="above">
                    <button type="button" class="action-drop" data-toggle="modal" data-target="#deleteDataModal"
                      aria-label="OpenDeleteModal" data-bs-toggle="tooltip" data-bs-placement="bottom"
                      (click)="selectRecordToDelete(history.barcode)">
                      <i><img width="20" src="../../../assets/Pricingscreen/delete.svg" /></i>
                    </button>
                  </span>
                </ng-template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!--No table data-->
      <div class="no-table-report text-center" *ngIf="!isLoading && (!isHistory || pagedData.length == 0)">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-4">
            There is no History available yet. <br />
            Please check back later
          </p>
        </div>
      </div>

      <!--  Loader-->
      <div class="d-flex flex-column justify-content-center h-100" *ngIf="isLoading">
        <div class="loader m-auto"></div>
      </div>
      </div>

      <!-- Pagination -->
      <div *ngIf="!isLoading && isHistory && totalRecords > 0" class="table-pagination">
        <app-pagination
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [pageSizes]="pageSizes"
          [pagesToShow]="pagesToShow"
          (pageChange)="onPageChange($event)"
          (itemsPerPageChange)="onItemsPerPageChange($event)"
        >
        </app-pagination>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div class="modal fade" id="filterData" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">

                <li (click)="selectedFilterCategory('Department')"
                  [ngClass]="{ 'active': filterName === 'Department' }">
                  Department
                  <br />
                  <p *ngIf="filterDepartmentIDs.length > 0">
                    {{ filterDepartmentIDs.length }} selected
                  </p>
                </li>

                <li (click)="selectedFilterCategory('Category')" [ngClass]="{ 'active': filterName === 'Category' }">
                  Category
                  <br />
                  <p *ngIf="filterCategoriesIDs.length > 0">
                    {{ filterCategoriesIDs.length }} selected
                  </p>
                </li>

                <li *ngIf="showWeekColor" (click)="selectedFilterCategory('Color')" [ngClass]="{ 'active': filterName === 'Color' }">
                  Color
                  <br />
                  <p *ngIf="filterColorIDs.length > 0">
                    {{ filterColorIDs.length }} selected
                  </p>
                </li>

              </ul>
            </div>

          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'Department'">
                <div class="col-lg-3 col-sm-6" *ngFor="let data of DeptCatArrayForFilters; let idx = index">
                  <div class="conntent-box" [ngClass]="{ active: data.isSelected == true }"
                    (click)="collectFilterParameters(data.departmentId)">
                    <i><img class="filtericon" [src]="data.dicon" /></i>
                    <span class="mt-2" style="font-size: 13px; text-align: center; color: black">{{ data.departmentDescr
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Category'">
                <div class="col-lg-3 col-sm-6" *ngFor="let data of DeptCatArrayForFilters; let idx = index"
                  (click)="collectFilterParameters(data.categoryId)">
                  <div class="conntent-box" [ngClass]="{ active: data.cIsSelected == true }">
                    <i><img class="filtericon" [src]="data.cicon" /></i>
                    <span class="mt-2" style="font-size: 13px; text-align: center; color: black">
                      {{ data.categoryName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Color' && showWeekColor">
                <div class="col-lg-3 col-sm-6" *ngFor="let data of DeptCatArrayForFilters; let idx = index"
                  (click)="collectFilterParameters(data.productionCycleId)">
                  <div class="conntent-box" [ngClass]="{ active: data.wIsSelected == true }">
                    <!-- <i><img class="filtericon" [src]="data.imageIcon" /></i>-->
                    <span class="bgColor" [style.backgroundColor]="data.color"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button class="btn modal-btn me-2" data-bs-dismiss="modal" aria-label="Close"
            style="background-color: #ffffff; color: #175f91" (click)="openFilterModal('Close')">
            Cancel
          </button>
          <button class="btn modal-btn me-2" data-bs-dismiss="modal" aria-label="Close"
            style="background-color: #175f91; color: white" (click)="getFilterData()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Btn for open modal-->
<button style="display: none" #checkBtn data-bs-toggle="modal" href="#checkPrice">
  btn
</button>
<!--Bostrap Modal for Special Brand-->
<div class="modal fade" id="checkPrice" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered">
    <div class="modal-content pricemodal">
      <div class="custom-modal-header modal-header" style="margin: auto">
        <h5 class="modal-title" id="exampleModalToggleLabel">
          Printing Please Wait!
        </h5>
      </div>
      <div class="custom-modal-body modal-body pricemodal-body">
        <div class="modal-body-wraapper" style="margin: auto; display: flex">
          <img src="../../../assets/Barcodes/printGIF.gif" style="width: 350px; height: 300px; margin: auto" />
        </div>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for deleting Department -->
<div class="modal fade" id="deleteDataModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="!deleteButtonClickedWithSelection && selectedIdToDelete <= 0">
        <h5>No Record Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection || selectedIdToDelete > 0">
        <div class="modal-body-wraapper">
          <p>Are you sure you want to delete the “Selected Records”?<br /></p>
          <p class="fw-bold mt-3">
            Once deleted, all the saved data will get deleted.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="!deleteButtonClickedWithSelection && selectedIdToDelete <= 0">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close" #modalConfirmCloseButton
          (click)="selectedIdToDelete = 0">
          Close
        </button>
        <button button class="btn modal-btn" data-dismiss="modal" aria-label="Close"
          *ngIf="deleteButtonClickedWithSelection || selectedIdToDelete > 0"
          style="background-color: rgb(23, 95, 145); color: white" (click)="
            selectedIdToDelete > 0
              ? delWorkingTbl(selectedIdToDelete)
              : deleteHistory()
          ">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>

<button style="display: none" #tagButton data-bs-toggle="modal" href="#printModal">
  btn
</button>
<div class="modal fade" id="printModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="isPrinting">
        <h5>Print</h5>
      </div>
      <div class="modal-header" *ngIf="isPrinting">
        <h5>No Record Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="isPrinting">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to print.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close" #modalConfirmCloseButton
          (click)="triggerTagButtonClick()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal for Failed Deletions -->
<div class="modal fade" [class.show]="showFailedDeleteModal" [style.display]="showFailedDeleteModal ? 'block' : 'none'"
  id="failedDeleteModal" aria-hidden="true" aria-labelledby="failedDeleteModalLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f8d7da; border-bottom: 1px solid #f5c6cb;">
        <h5 class="modal-title" id="failedDeleteModalLabel" style="color: #721c24;">
          <i class="fa-solid fa-triangle-exclamation me-2"></i>
          Partial Success - Some Deletions Failed
        </h5>
        <button type="button" class="btn-close" (click)="closeFailedDeleteModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-warning mb-3" role="alert">
          <strong>{{deleteSuccessCount}}</strong> serials deleted successfully.
          <strong>{{failedToDeleteSerials.length}}</strong> failed to delete.
        </div>

        <h6 class="mb-3">Failed Deletions:</h6>
        <div class="table-responsive"
          style="max-height: 400px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px;">
          <table class="table table-bordered table-sm mb-0" style="border-collapse: collapse;">
            <thead class="sticky-top" style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6;">
              <tr>
                <th scope="col" style="width: 40%; border: 1px solid #dee2e6; padding: 12px;">Serial Number</th>
                <th scope="col" style="width: 60%; border: 1px solid #dee2e6; padding: 12px;">Error Message</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let failed of failedToDeleteSerials" style="border-bottom: 1px solid #dee2e6;">
                <td style="border: 1px solid #dee2e6; padding: 10px; vertical-align: middle;">{{ failed.serialNumber }}
                </td>
                <td class="text-danger" style="border: 1px solid #dee2e6; padding: 10px; vertical-align: middle;">{{
                  failed.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn modal-btn" style="background-color: #175f91; color: white;"
          (click)="closeFailedDeleteModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showFailedDeleteModal"
  [style.display]="showFailedDeleteModal ? 'block' : 'none'" *ngIf="showFailedDeleteModal"></div>
